import type { Dayjs } from 'dayjs';

/** A history-table date filter window; half-set ranges do not narrow (see dateRangeToMsBounds). */
export type DateRangeTuple = [Dayjs | null, Dayjs | null];

/**
 * A complete range as inclusive epoch-ms bounds covering whole local-time days
 * (min/max-normalized), or null while either bound is unset — an incomplete range
 * filters nothing. Single owner of the range's granularity/inclusivity semantics,
 * shared by row filtering (historyStoreFactory) and paging depth (useHistory).
 */
export const dateRangeToMsBounds = (range?: DateRangeTuple): { lo: number; hi: number } | null => {
  const [from, to] = range ?? [null, null];
  if (from == null || to == null) return null;
  return {
    lo: Math.min(from.startOf('day').valueOf(), to.startOf('day').valueOf()),
    hi: Math.max(from.endOf('day').valueOf(), to.endOf('day').valueOf()),
  };
};
